module.exports = __webpack_public_path__ + "img/en-tur-i-tivoli-5.61602d4b.png";